document.addEventListener("DOMContentLoaded", function () {
    initializeSwiper();
  
    var load_more_btn = document.querySelector(".show_more_btn");
    var blog_on_page = document.querySelector(".posts-list");
    var next_url = blog_on_page.getAttribute("data-next-url");
    var scrolled = false;
  
    if (load_more_btn) {
      bindScrollEvent();
    }
  
    function bindScrollEvent() {
      window.addEventListener(
        "scroll",
        function () {
          if (!scrolled) {
            scrolled = true;
            if (isInViewport(load_more_btn, 500)) {
              loadMorePosts(load_more_btn, next_url, blog_on_page);
            }
            setTimeout(function () {
              scrolled = false;
            }, 500);
          }
        },
        true
      );
    }
  });
  
  function initializeSwiper() {
    new Swiper(".swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });
  }
  
  const isInViewport = (elem, offset) => {
    var bounding = elem.getBoundingClientRect();
  
    bounding.y = bounding.y - offset;
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  function loadMorePosts(load_more_btn, next_url, blog_on_page) {
    load_more_btn.style.display = "block";
  
    fetch(next_url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then((next_page) => {
        load_more_btn.style.display = "none";
  
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = next_page;
  
        const new_posts = tempDiv.querySelector(".posts-list");
  
        const new_url = new_posts?.dataset.nextUrl;
  
        if (new_url) {
          next_url = new_url;
        }
  
        blog_on_page.innerHTML += new_posts.innerHTML;
      })
      .catch((error) => {
        console.error("Erro ao buscar a próxima página:", error);
      });
  }
  